(() => {
  'use strict';
  if (window.__sdProductClarity) return;
  window.__sdProductClarity = true;

  const roots = (scope = document) => {
    const out = [];
    if (scope.matches && scope.matches('[data-sdp-product]')) out.push(scope);
    if (scope.querySelectorAll) out.push(...scope.querySelectorAll('[data-sdp-product]'));
    return out;
  };

  function hideDefaultMaster(root) {
    const master = root.querySelector('select[name="id"][id^="ProductSelect-"]');
    if (!master) return;
    const options = Array.from(master.options || []);
    if (options.length !== 1) return;
    const label = (options[0].textContent || '').replace(/\s+/g, ' ').trim();
    if (!/^Default Title(?:\s*[—-].*)?$/i.test(label)) return;
    master.hidden = true;
    master.classList.add('sd-single-master-hidden');
    master.setAttribute('aria-hidden', 'true');
    master.tabIndex = -1;
  }

  const shippingMarkup = `
    <div class="sd-shipping-mini">
      <strong>Estimated delivery: 1–4 days</strong>
      <p>Shipping methods and costs are shown at checkout. Delivery timing is an estimate and can shift because of carrier delays, weather, holidays, address issues, or other events outside our control.</p>
      <a href="/policies/shipping-policy">Read the full shipping policy</a>
    </div>`;

  function upgradeShipping(root) {
    let inlineDetails = Array.from(root.querySelectorAll('.sd-trust-rows details')).find((details) => {
      const summary = details.querySelector('summary');
      return summary && /delivery|shipping/i.test(summary.textContent || '');
    });

    if (inlineDetails) {
      inlineDetails.id = 'ShadowsShippingDetails';
      const summary = inlineDetails.querySelector('summary');
      if (summary) summary.textContent = 'Shipping & delivery';
      Array.from(inlineDetails.children).forEach((child) => {
        if (child.tagName !== 'SUMMARY') child.remove();
      });
      inlineDetails.insertAdjacentHTML('beforeend', shippingMarkup);
    }

    const accordion = Array.from(root.querySelectorAll('.sdp-accordions details')).find((details) => {
      const summary = details.querySelector('summary');
      return summary && /delivery|shipping/i.test(summary.textContent || '');
    });
    if (accordion) {
      const summary = accordion.querySelector('summary');
      if (summary) summary.textContent = 'Shipping & delivery';
      const content = accordion.querySelector('.sdp-details__content');
      if (content) content.innerHTML = shippingMarkup;
      if (!inlineDetails) {
        accordion.id = 'ShadowsShippingDetails';
        inlineDetails = accordion;
      }
    }

    const assurance = root.querySelector('.sdp-assurance[href*="/policies/shipping-policy"]');
    if (assurance) {
      assurance.setAttribute('href', '#ShadowsShippingDetails');
      const strong = assurance.querySelector('strong');
      const small = assurance.querySelector('small');
      if (strong) strong.textContent = 'Shipping & delivery';
      if (small) small.textContent = 'Estimated 1–4 days';
      if (!assurance.dataset.sdShippingBound) {
        assurance.dataset.sdShippingBound = '1';
        assurance.addEventListener('click', (event) => {
          const target = root.querySelector('#ShadowsShippingDetails');
          if (!target) return;
          event.preventDefault();
          target.open = true;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    }
  }

  function reviewCount(badge) {
    const n = Number(String((badge && badge.dataset.numberOfReviews) || '0').replace(/,/g, ''));
    return Number.isFinite(n) ? n : 0;
  }

  function ratingFor(badge) {
    const n = Number((badge && badge.dataset.averageRating) || 0);
    return Number.isFinite(n) ? n : 0;
  }

  function fullReviewsLoaded(widget) {
    return !!(widget && widget.querySelector('.jdgm-rev, .jdgm-rev__body, [data-review-id]'));
  }

  function injectJudgeMeSSR(widget) {
    if (!widget || fullReviewsLoaded(widget)) return false;
    const source = document.getElementById('ShadowsJudgeMeSSR');
    if (!source || !source.content || !source.content.querySelector('.jdgm-rev')) return false;
    widget.replaceChildren(source.content.cloneNode(true));
    widget.dataset.sdSsrReviews = 'true';
    return fullReviewsLoaded(widget);
  }

  function upgradeReviews(root) {
    const reviews = root.querySelector('.sdp-reviews');
    const widget = reviews && reviews.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
    const badge = root.querySelector('.jdgm-prev-badge');
    if (!reviews || !badge) return;

    if (reviews.id !== 'ShadowsProductReviews') reviews.id = 'ShadowsProductReviews';

    const count = reviewCount(badge);
    const rating = ratingFor(badge);
    if (count <= 0) return;

    if (widget) {
      widget.dataset.autoInstall = 'true';
      widget.dataset.fromSnippet = 'true';
      widget.hidden = false;
      widget.removeAttribute('aria-hidden');
    }

    let loaded = fullReviewsLoaded(widget) || injectJudgeMeSSR(widget);

    if (loaded) {
      const oldFallback = reviews.querySelector('[data-sd-review-fallback]');
      if (oldFallback) oldFallback.hidden = true;
      if (window.jdgm && typeof window.jdgm.initWidgets === 'function') {
        try { window.jdgm.initWidgets(); } catch (_) {}
      }
      return;
    }

    let fallback = reviews.querySelector('[data-sd-review-fallback]');
    if (!fallback) {
      fallback = document.createElement('div');
      fallback.className = 'sd-review-fallback';
      fallback.dataset.sdReviewFallback = '';
      fallback.hidden = true;
      const heading = reviews.querySelector('.sdp-section-heading');
      if (heading) heading.insertAdjacentElement('afterend', fallback);
      else reviews.prepend(fallback);
    }

    const ratingText = rating > 0 ? `${rating.toFixed(2)}/5` : 'Customer rated';
    fallback.innerHTML = `
      <div class="sd-review-fallback__score"><span aria-hidden="true">★★★★★</span><strong>${ratingText}</strong></div>
      <p><strong>${count} published customer reviews</strong> are attached to this product. Judge.me is still loading the individual review cards. Use the button below to retry the reviews without leaving this product.</p>
      <a class="button button--secondary" href="#ShadowsProductReviews" data-sd-review-retry>Browse customer reviews</a>`;

    const retry = fallback.querySelector('[data-sd-review-retry]');
    if (retry && !retry.dataset.sdReviewRetryBound) {
      retry.dataset.sdReviewRetryBound = '1';
      retry.addEventListener('click', (event) => {
        event.preventDefault();
        if (window.jdgm && typeof window.jdgm.initWidgets === 'function') {
          try { window.jdgm.initWidgets(); } catch (_) {}
        }
        loaded = fullReviewsLoaded(widget) || injectJudgeMeSSR(widget);
        reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => {
          loaded = fullReviewsLoaded(widget) || injectJudgeMeSSR(widget);
          fallback.hidden = loaded;
          if (!loaded) {
            retry.textContent = 'Reviews are still loading';
            retry.setAttribute('aria-disabled', 'true');
          }
        }, 500);
      });
    }

    if (window.jdgm && typeof window.jdgm.initWidgets === 'function') {
      try { window.jdgm.initWidgets(); } catch (_) {}
    }

    window.setTimeout(() => {
      loaded = fullReviewsLoaded(widget) || injectJudgeMeSSR(widget);
      fallback.hidden = loaded;
      if (loaded && window.jdgm && typeof window.jdgm.initWidgets === 'function') {
        try { window.jdgm.initWidgets(); } catch (_) {}
      }
    }, 1200);
  }

  function normalizeDeliveryCue(root) {
    root.querySelectorAll('[data-sdc3-cues] [data-x="d"]').forEach((cue) => {
      cue.textContent = 'Estimated delivery: 1–4 days';
    });
  }

  function enhance(scope = document) {
    roots(scope).forEach((root) => {
      hideDefaultMaster(root);
      upgradeShipping(root);
      normalizeDeliveryCue(root);
      upgradeReviews(root);
    });
  }

  function boot() {
    enhance(document);
    [250, 900, 1800, 3500].forEach((ms) => window.setTimeout(() => enhance(document), ms));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => window.requestAnimationFrame(() => enhance(event.target || document)));
})();
